import { FrontendConfig } from '../../src/interfaces/config';

export const defaultFrontConfig: FrontendConfig = {
  google: {
    authClientId: '',
  },
  siderLogoUrl: '',
  isSchedulesModuleEnabled: 'false',
  isIncidencesModuleEnabled: 'true',
  isMyIncidenceRequestsEnabled: 'true',
  isIncidenceAuthorizationsEnabled: 'true',
};
